import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Buffets from "@/pages/Buffets";
import About from "@/pages/About";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App min-h-screen bg-ink-900 text-foreground font-body">
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <CartProvider>
            <Navbar />
            <AuthModal />
            <CartDrawer />
            <main className="min-h-[60vh]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/buffets" element={<Buffets />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/commander" element={<Checkout />} />
                <Route path="/confirmation" element={<Confirmation />} />
                <Route path="/compte" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors theme="dark" />
          </CartProvider>
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
